<template>
  <div>
    <b-card>
      <b-card-body>
        <b-card-text>OVERVIEW</b-card-text>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('billing/retrieveCloudPricing').then((result) => {
      console.info('GOT CLOUD PRICING', result);
    });
  },
};
</script>

<style scoped>

</style>
